<template>
  <div class="wkcal" :style="{'--ppm': ppm + 'px'}">
    <!-- Header: Thời gian + 7 ngày -->
    <div class="header">
      <div class="hdr-left">Thời gian</div>
      <div
          v-for="(d, i) in headers"
          :key="i"
          class="day-hdr"
      >
        <span>{{ d.label }}</span>
        <small>{{ d.dateText }}</small>
      </div>
    </div>

    <!-- Body: cột nhãn + 7 cột ngày -->
    <div class="body">
      <!-- cột nhãn trái -->
      <div class="labels">
        <div class="slot" :style="bandStyle('morning')">
          <div class="timeScale">
            <div class="tick" v-for="h in [8,9,10,11,12]" :key="'m'+h" :style="{top: toBandTop('morning', h)+ 'px'}">
              {{ hhmm(h) }}
            </div>
          </div>

        </div>
      </div>

      <!-- 7 cột ngày -->
      <div
          v-for="(d, dayIdx) in headers"
          :key="'col'+dayIdx"
          class="day"
          :data-date="d.iso"
      >
        <div class="band" data-name="morning" :style="bandStyle('morning')">
          <div v-if="isOff(d.iso,'morning')" class="off">Không đi làm</div>

          <div
              v-for="(ev, i) in dayBandEvents(d.iso,'morning')"
              :key="'m-ev-'+i"
              class="event"
              :class="ev.color"
              :data-time="ev.start + ' – ' + ev.end"
              :style="eventStyle(ev, 'morning')"
              v-text="ev.title"
          />
        </div>

        <div class="band" data-name="afternoon" :style="bandStyle('afternoon')">
          <div v-if="isOff(d.iso,'afternoon')" class="off">Không đi làm</div>

          <div
              v-for="(ev, i) in dayBandEvents(d.iso,'afternoon')"
              :key="'a-ev-'+i"
              class="event"
              :class="ev.color"
              :data-time="ev.start + ' – ' + ev.end"
              :style="eventStyle(ev, 'afternoon')"
              v-text="ev.title"
          />
        </div>

        <div class="band" data-name="evening" :style="bandStyle('evening')">
          <div v-if="isOff(d.iso,'evening')" class="off">Không đi làm</div>

          <div
              v-for="(ev, i) in dayBandEvents(d.iso,'evening')"
              :key="'e-ev-'+i"
              class="event"
              :class="ev.color"
              :data-time="ev.start + ' – ' + ev.end"
              :style="eventStyle(ev, 'evening')"
              v-text="ev.title"
          />
        </div>
      </div>

      <!-- ghi chú -->
      <div class="legend">
        <span class="dot blue"></span> 1057 – Gia sư
        <span class="dot pink" style="margin-left:12px;"></span> 1059 – Tác vụ khác
        <span class="dot gray" style="margin-left:12px;"></span> Không đi làm
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "test",
  props: {
    /**
     * events: [
     *  { date: '2025-02-15', band:'morning|afternoon|evening',
     *    start:'09:00', end:'11:00', title:'...', color:'blue|pink' }
     * ]
     */
    events: { type: Array, default: () => [] },
    /**
     * offDays: { '2025-02-13': ['morning','afternoon','evening'], ... }
     */
    offDays: { type: Object, default: () => ({}) },
    /**
     * refDate: ngày bất kỳ trong tuần cần render (ISO yyyy-mm-dd)
     * mặc định = hôm nay
     */
    refDate: { type: String, default: () => new Date().toISOString().slice(0,10) },
    /** pixels per minute (độ cao dọc) */
    ppm: { type: Number, default: 1.2 }
  },
  data() {
    return {
      bands: {
        morning:  { start: 8*60,  end: 12*60 },  // 08:00–12:00
        afternoon:{ start: 13*60, end: 17*60 },  // 13:00–17:00
        evening:  { start: 18*60, end: 21*60 }   // 18:00–21:00
      }
    };
  },
  computed: {
    weekStart() { // Monday of the week that contains refDate
      const d = new Date(this.refDate + "T00:00:00");
      const day = d.getDay(); // 0=Sun..6=Sat
      const diff = (day + 6) % 7; // days since Monday
      d.setDate(d.getDate() - diff);
      return d;
    },
    headers() { // 7 days header info
      const out = [];
      for (let i = 0; i < 7; i++) {
        const d = new Date(this.weekStart);
        d.setDate(this.weekStart.getDate() + i);
        out.push({
          iso: d.toISOString().slice(0, 10),
          dateText: d.toLocaleDateString("vi-VN", { day: "2-digit", month: "2-digit", year: "numeric" }),
          label: ["Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7","Chủ nhật"][i]
        });
      }
      return out;
    }
  },
  methods: {
    toMin(hhmm) { const [h,m] = hhmm.split(":").map(Number); return h*60 + m; },
    hhmm(h) { return `${("0"+h).slice(-2)}:00`; },
    bandHeight(name) { const b = this.bands[name]; return (b.end - b.start) * this.ppm; },
    bandStyle(name) {
      return { height: this.bandHeight(name) + "px" };
    },
    toBandTop(name, hour) {
      const b = this.bands[name];
      return ( (hour*60) - b.start ) * this.ppm;
    },
    isOff(iso, band) {
      const arr = this.offDays[iso];
      return Array.isArray(arr) && arr.indexOf(band) !== -1;
    },
    dayBandEvents(iso, band) {
      return this.events.filter(e => e.date === iso && e.band === band);
    },
    eventStyle(ev, band) {
      const b = this.bands[band];
      const startAbs = this.toMin(ev.start);
      const endAbs   = this.toMin(ev.end);
      const start = Math.max(0, startAbs - b.start);
      const end   = Math.max(start + 10, endAbs - b.start); // tối thiểu 10'
      return {
        top: (start * this.ppm) + "px",
        height: ((end - start) * this.ppm) + "px"
      };
    }
  }
};
</script>

<style scoped>
:root{}
.wkcal{
  --sidebarW: 120px;
  --headerH: 64px;
  --gap: 1px;
  --line: #e5e7eb;
  --line2:#f2f4f7;
  --text:#111827;
  --muted:#6b7280;
  --blue:#1677ff; --blueBg:#e8f1ff;
  --pink:#ef6a7b; --pinkBg:#ffe9ed;
  --gray:#9aa0a6; --grayBg:#ececec;
  color: var(--text);
  display:grid;
  grid-template-columns: var(--sidebarW) repeat(7, 1fr);
  grid-template-rows: var(--headerH) 1fr;
  height: 100%;
  min-height: 520px;
  overflow: hidden;
  font:14px/1.4 ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial;
}

/* header */
.header{
  grid-column: 1 / -1;
  display:grid;
  grid-template-columns: subgrid;
  position: sticky; top: 0; z-index: 2;
  background: #fff;
  border-bottom:1px solid var(--line);
}
.hdr-left{
  display:flex; align-items:center; justify-content:center;
  font-weight:600; color:var(--muted); border-right:1px solid var(--line);
}
.day-hdr{
  border-left:1px solid var(--line);
  display:flex; align-items:center; justify-content:center;
  gap:.5rem; font-weight:700;
}
.day-hdr small{color:var(--muted); font-weight:600}

/* body */
.body{
  grid-column: 1 / -1;
  display:grid;
  grid-template-columns: var(--sidebarW) repeat(7, 1fr);
  overflow:auto;
}
.labels{ border-right:1px solid var(--line); }
.slot{
  position:relative;
  border-bottom:1px solid var(--line);
  display:flex; align-items:center; justify-content:center;
  font-weight:700; color:#374151;
}

.day{ border-left:1px solid var(--line); }
.band{
  position:relative;
  border-bottom:1px solid var(--line);
  background:
      repeating-linear-gradient(
          to bottom,
          #0000,
          #0000 calc(60*var(--ppm) - var(--gap)),
          var(--line) calc(60*var(--ppm) - var(--gap)),
          var(--line) calc(60*var(--ppm))
      ),
      repeating-linear-gradient(
          to bottom,
          #0000,
          #0000 calc(30*var(--ppm) - var(--gap)),
          var(--line2) calc(30*var(--ppm) - var(--gap)),
          var(--line2) calc(30*var(--ppm))
      );
}

/* event block */
.event{
  position:absolute; left:8px; right:8px;
  border-radius:10px; padding:.35rem .5rem;
  display:flex; align-items:center;
  font-weight:700; font-size:13px;
  box-shadow: 0 1px 0 rgba(0,0,0,.05), 0 6px 18px rgba(0,0,0,.05);
  border:1px solid transparent;
  overflow:hidden;
}
.event.blue{ background:var(--blueBg); color:#113a8f; border-color:#cfe0ff; }
.event.pink{ background:var(--pinkBg); color:#8f2431; border-color:#ffd0d7; }

.event[data-time]::after{
  content: attr(data-time);
  position:absolute; top:-22px; left:8px;
  background:#111827; color:#fff; padding:2px 6px; border-radius:4px;
  font-weight:600; font-size:12px; white-space:nowrap; opacity:0; pointer-events:none;
  transform:translateY(-4px); transition:.15s;
}
.event:hover::after{ opacity:1; transform:translateY(0); }

/* off block */
.off{
  position:absolute; inset:0;
  background: repeating-linear-gradient(
      -45deg,
      var(--grayBg), var(--grayBg) 10px,
      #f6f6f6 10px, #f6f6f6 20px
  );
  border:1px dashed var(--gray);
  border-radius:8px; color:#555; font-weight:700;
  display:flex; align-items:center; justify-content:center;
}

/* time scale ticks */
.timeScale{ position:absolute; inset:0; pointer-events:none; }
.tick{ position:absolute; left:0; right:0; height:0;
  transform: translateY(-.6em);
  text-align:center; color:var(--muted); font-size:12px; font-weight:600;
}

/* legend */
.legend{
  padding:.5rem .75rem; border-top:1px solid var(--line);
  grid-column: 1 / -1; display:flex; gap:1rem; align-items:center; color:#374151;
  background:#fafafa;
}
.dot{width:12px; height:12px; border-radius:999px}
.dot.blue{background:var(--blue)}
.dot.pink{background:var(--pink)}
.dot.gray{background:var(--gray)}
</style>
